import { ArticulationType } from '@models/editor/Articulation'
import { PartType } from '@models/editor/Part'

export interface Sequence {
  parts: PartType[]
  scorePositionMap?: TemporalMap
  performance: Performance
  noteTimes: NoteTime[]
  scoreMix?: ScoreMix
}

export interface Performance {
  elements: Note[]
}

export type TemporalMap = {
  parts: PartType[]
  noteTimes: NoteTime[]
  performance: SynthPerformace
  scoreMix: ScoreMix
  timeMap: TimePosition[]
  length: number
  startTime: number
  startPosition: number
  startTimeScale: number
  lastMeasureIndexWithEntry: number
}

export type TimePosition = {
  onset: number
  scorePosition: number
  timescale: number
}

export type ScoreMix = {
  masterGain: number
  reverbLevel: number
  reverbType: string
}

export type NoteTime = {
  startTime: number
  endTime: number
}

export type SynthPerformace = {
  duration: number
  elements: Note[] | null[]
  endTime: number
  lastOnset: number
  panNode: GainNode
}

export type Note = {
  onset: number // the note's start time (as score position)
  duration: number // relative to onset
  tunedOrdinal: number // the pitch. MIDI note number, except it doesn't have to be an integer
  velocity: number //  MIDI note velocity
  pitchModulations?: PitchModulation[] | null
  channel: number
  panNode: GainNode
  // Could these two variables be condensed into one?
  articulation?: Articulation
  articulationValue?: ArticulationType
}

export interface Articulation {
  value: ArticulationType
}

export interface PitchModulation {
  startTime: number // offset in ticks from the note's onset
  endTime: number // offset in ticks from the note's onset
  // parameters for pitch modulation
  maxValue: number
  frequency: number
  name: Modulation
}
export interface Modulation {
  startTime: number // in absolute seconds
  endTime: number // in absolute seconds
  name: ModulationType
  modulation?: Modulation
  frequency: number
  maxValue: number
}

export interface PlaybackNote {
  pitchSource: AudioBufferSourceNode
  gainNode: GainNode
}

export enum ModulationType {
  BEND = 'bend',
  SLIDE = 'slide',
  VIBRATO = 'vibrato',
}

export interface ScheduleNote {
  gainNode: GainNode
  endTime: number
}
